import { AccessorsMutatorsDecorator, isInstanceOf } from "../../helpers";
import { TranslatableModel } from "./translatable-model";
import { Property } from "./property.model";

/**
 * @class PropertyType
 * @property {number} id
 * @property {string} title
 * @property {string} status
 */
export class PropertyType extends TranslatableModel {

    /**
     * @type {string[]}
     */
    static get translatableAttributes() {

        return [ 'title' ];
    }
    
    static get validationModel() {

        return {
            title: {
                label: 'TYPE_NAME_IN_ENGLISH',
                commonLabel: 'Type name'
            },
            title_ar: {
                label: 'TYPE_NAME_IN_ARABIC',
                commonLabel: 'Type name'
            },
        };
    }
    
    setProperties(value) {
        
        if (!Array.isArray(value) || !isInstanceOf(Property, value[0])) {
            
            value = Property.factory(value);
        }
        
        return value;
    }
}

AccessorsMutatorsDecorator('id', ...PropertyType.translatableAttributesWithLanguageAliases, 'status', 'properties', 'ota_hotel_type')(PropertyType);


// WEBPACK FOOTER //
// ./src/pms-api/models/property-type.model.js